import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { Theme, ThemeLayout } from './pages/Styles/Theme';
import { ThemeProvider } from 'styled-components';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

import './pages/index.css';
import Sidebar from './Components/Sidebar/Sidebar';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';






import CampaignLandingPage from './pages/Campaigns/CampaignLandingPage';











import { GlobalMasterStyle } from './pages/Styles/MasterStyle';




import Login from './pages/Login/Login';
import PrivateRoute from './Components/common/PrivateRoute';
import NotFoundPage from './Components/common/NotFoundPage';
import { useDispatch } from 'react-redux';
import { initializeAuth } from './store/actions/loginAction';
import { initializePermissions } from './store/actions/permissionsAction';





import VerifyInvitation from './pages/VerifyInvitation/VerifyInvitation';
import SetPassword from './pages/SetPassword/SetPassword';


import MagicLinkVerify from './pages/Login/MagicLinkVerify';
import MagicLinkLanding from './pages/Login/MagicLinkLanding';
// "-new" auth pages — visual revamp, hidden behind URL prefix. Logic identical to originals.
import LoginNew from './pages/Login/Login-new';
import MagicLinkVerifyNew from './pages/Login/MagicLinkVerify-new';
import MagicLinkLandingNew from './pages/Login/MagicLinkLanding-new';
import VerifyInvitationNew from './pages/VerifyInvitation/VerifyInvitation-new';
import SetPasswordNew from './pages/SetPassword/SetPassword-new';
import SessionInvalidatedModal from './Components/common/SessionInvalidatedModal';
import SessionExpiredModal from './Components/common/SessionExpiredModal';
import IntercomGate from './Components/common/IntercomGate';
import useWindowWidth, { MOBILE_BREAKPOINT, COMPACT_BREAKPOINT } from './hooks/useWindowWidth';

// Route-level code splitting: heavy authenticated pages load as separate
// chunks so the public pages (login, campaign landing) ship a small bundle.
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const CreatePollingAgent = lazy(() => import('./pages/PollingAgents/CreatePollingAgent'));
const PollingAgents = lazy(() => import('./pages/PollingAgents/PollingAgent'));
const PollAgents = lazy(() => import('./pages/PollingAgents/PollAgents'));
const Campaigns = lazy(() => import('./pages/Campaigns/Campaigns'));
const CreateCampaign = lazy(() => import('./pages/Campaigns/CreateCampaign'));
const CampaignDetail = lazy(() => import('./pages/Campaigns/CampaignDetail'));
const SurveysList = lazy(() => import('./pages/Surveys/SurveysList'));
const SetUpStudy = lazy(() => import('./pages/Surveys/SetUpStudy'));
const Preview = lazy(() => import('./pages/Surveys/SurveyComponents/Preview/Preview'));
const Project = lazy(() => import('./pages/Projects/Project'));
const ProjectDetails = lazy(() => import('./pages/Projects/ProjectDetails'));
const SignalDashboardHistory = lazy(() => import('./pages/Projects/SignalDashboardHistory'));
const WeightingManager = lazy(() => import('./pages/Projects/WeightingManager'));
const PromptLibrary = lazy(() => import('./pages/Projects/PromptLibrary/PromptLibrary'));
const DefaultGpt = lazy(() => import('./pages/Projects/DefaultGpt'));
const GptChat = lazy(() => import('./pages/Projects/GptChat'));
const Share = lazy(() => import('./pages/Surveys/Share/Share'));
const Gpt = lazy(() => import('./pages/Projects/Gpt'));
const InsightEngineChat = lazy(() => import('./pages/Projects/InsightEngineChat'));
const CreateSurvey = lazy(() => import('./pages/Surveys/CreateSurvey'));
const LaunchSurvey = lazy(() => import('./pages/Surveys/LaunchSurvey'));
const Manage = lazy(() => import('./pages/Manage/Manage'));
const Organization = lazy(() => import('./pages/Organization/Organization'));
const AddEditOrganization = lazy(() => import('./pages/Organization/AddEditOrganization'));
const InsightEngine = lazy(() => import('./pages/Projects/InsightEngine'));
const UserActivity = lazy(() => import('./pages/Monitoring/UserActivity'));
const UserTracking = lazy(() => import('./pages/Monitoring/UserTracking'));
const GenZSignals = lazy(() => import('./pages/Projects/GenZSignals'));
const GenZDashboard = lazy(() => import('./pages/GenZDashboard/GenZDashboard'));
const VitalCityDashboard = lazy(() => import('./pages/VitalCityDashboard/VitalCityDashboard'));
const NewCampaign = lazy(() => import('./pages/Campaigns/NewCampaign'));
const LiveStudiesMonitor = lazy(() => import('./pages/Campaigns/LiveStudiesMonitor'));
const SurveyEntry = lazy(() => import('./pages/SurveyEntry/SurveyEntry'));

// Initialize auth on app load
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth and permissions from localStorage
    dispatch(initializeAuth());
    dispatch(initializePermissions());
  }, [dispatch]);

  return <>{children}</>;
};

// Layout component that includes sidebar and header for all pages
const AppLayout = () => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= MOBILE_BREAKPOINT;
  const isCompact = windowWidth < COMPACT_BREAKPOINT;

  // localStorage holds the *desktop* preference only. Below COMPACT_BREAKPOINT the
  // sidebar is auto-collapsed to the icon rail; the toggle still works there, but
  // those clicks aren't persisted so the desktop preference survives.
  const [collapsed, setCollapsed] = useState(
    () => isCompact || localStorage.getItem('sidebar_collapsed') === 'true'
  );

  // Re-apply on every crossing of the breakpoint, in both directions.
  const wasCompactRef = useRef(isCompact);
  useEffect(() => {
    if (isCompact === wasCompactRef.current) return;
    wasCompactRef.current = isCompact;
    setCollapsed(isCompact ? true : localStorage.getItem('sidebar_collapsed') === 'true');
  }, [isCompact]);

  const toggle = (data) => {
    setCollapsed(data);
    if (!isCompact) localStorage.setItem('sidebar_collapsed', String(data));
  };

  const sidebarWidth = collapsed ? 60 : 210;

  return (
    <>
      <GlobalMasterStyle />
      <IntercomGate />
      <ThemeLayout>
        <Sidebar collapsed={collapsed} collapsedWidth={60} toggle={(data) => toggle(data)} />
        <Layout>
          <Content
            className="mainContent"
            style={{
              marginLeft: isMobile ? 0 : sidebarWidth,
              width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`,
              transition: 'all 0.2s ease',
            }}
          >
            <div
              style={{
                marginLeft: '0px',
                width: '100%',
              }}
            >
              <main className="px-5 py-4">
                <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                  <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                <Outlet />
              </Suspense>
                </Suspense>
              </main>
            </div>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Layout component without sidebar and header
const NoSidebarLayout = () => {
  return (
    <>
      <GlobalMasterStyle />
      <IntercomGate />
      <ThemeLayout>
        <Layout>
          <Content
            className="mainContentNoSidebar"
            style={{
              marginLeft: 0,
              width: '100%',
              transition: 'all 0.2s ease',
            }}
          >
            <main className="p-0">
              <Suspense fallback={<div style={{ padding: 80, textAlign: "center" }}>Loading…</div>}>
                <Outlet />
              </Suspense>
            </main>
          </Content>
        </Layout>
      </ThemeLayout>
    </>
  );
};

// Define routes
const router = createBrowserRouter([
  {
    // Canonical /login now renders the new visual design. Original <Login /> is
    // kept in the codebase + imported as rollback safety (one-line revert).
    path: '/login',
    element: <LoginNew />,
  },
  // /login-new still mounted so the design URL keeps working for any direct
  // links or tester bookmarks; it's now a duplicate of /login.
  {
    path: '/login-new',
    element: <LoginNew />,
  },
  // Public route for campaign landing page (no auth required)
  {
    path: '/campaign/:slug/:code',
    element: <CampaignLandingPage />,
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <AppLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: '/',
        element: <Dashboard />,
      },
      {
        path: '/polling-agents/',
        element: <PollAgents />,
      },
      {
        path: '/polling-agents/polling-agent',
        element: <PollingAgents />,
      },
      {
        path: '/polling-agents/polling-agent/create-polling-agent',
        element: <CreatePollingAgent />,
      },
      {
        path: '/polling-agents/polling-agent/create-polling-agent/:id',
        element: <CreatePollingAgent />,
      },
      {
        path: '/campaigns/',
        element: <Campaigns />,
      },
      {
        path: '/campaigns/create-campaign',
        element: <CreateCampaign />,
      },
      {
        path: '/campaigns/new-campaign',
        element: <NewCampaign />,
      },
      {
        path: '/campaigns/new-campaign/:id',
        element: <NewCampaign />,
      },
      {
        path: '/campaigns/create-campaign/:id',
        element: <CreateCampaign />,
      },
      {
        path: '/campaigns/live-monitor',
        element: <LiveStudiesMonitor />,
      },
      {
        path: '/campaigns/:id',
        element: <CampaignDetail />,
      },
      {
        path: '/projects/',
        element: <Project />,
      },
      {
        path: '/projects/details/:id',
        element: <ProjectDetails />,
      },
      {
        path: '/projects/:id/prompt-library',
        element: <PromptLibrary />,
      },
      {
        path: '/projects/:projectId/signals/history',
        element: <SignalDashboardHistory />,
      },
      {
        path: '/projects/:projectId/weighting',
        element: <WeightingManager />,
      },
      {
        path: "/gen-z-dashboard/",
        element: <GenZDashboard />,
      },
      {
        path: "/vitalcity/",
        element: <VitalCityDashboard />,
      },
      {
        path: "/genz-signals/",
        element: <GenZSignals />,
      },
      {
        path: "/genz-signals/:chatId",
        element: <InsightEngineChat genzMode={true} />,
      },
      {
        path: '/insight-engine/',
        element: <InsightEngine />,
      },
      {
        path: '/insight-engine/gpt',
        element: <Gpt />,
      },
      {
        path: '/insight-engine/default',
        element: <DefaultGpt />,
      },
      {
        path: '/insight-engine/:chatId',
        element: <InsightEngineChat />,
      },
      {
        path: '/surveys/',
        element: <SurveysList />,
      },
      {
        path: '/surveys/launch-survey',
        element: <LaunchSurvey />,
      },
      {
        path: '/manage',
        element: <Manage />,
      },
      {
        path: '/organizations',
        element: <Organization />,
      },
      {
        path: '/organizations/new',
        element: <AddEditOrganization />,
      },
      {
        path: '/organizations/:id',
        element: <AddEditOrganization />,
      },
      {
        path: '/monitoring/users/:userId',
        element: <UserActivity />,
      },
      {
        path: '/user-tracking',
        element: <UserTracking />,
      },
    ],
  },
  // Separate route for Study page without sidebar
  {
    path: '/surveys/study',
    element: (
      <PrivateRoute>
        <NoSidebarLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: '/surveys/study/:surveyId',
        element: <CreateSurvey />,
      },
      {
        path: '/surveys/study/set-up-study',
        element: <SetUpStudy />,
      },
      {
        path: '/surveys/study/set-up-study/preview',
        element: <Preview />,
      },
      {
        path: '/surveys/study/set-up-study/share/',
        element: <Share />,
      },
    ],
  },
  {
    path: '/survey-entry',
    element: <SurveyEntry />,
  },
  // Public routes for user registration flow — canonical URLs now render the
  // new visual design. Original components are still imported as rollback
  // safety (swap the element back if anything regresses).
  {
    path: '/auth/xv7k2m/:token',
    element: <VerifyInvitationNew />,
  },
  {
    path: '/auth/np2w8q',
    element: <SetPasswordNew />,
  },
  // Sign-in link 2FA public routes (user-visible)
  {
    path: '/auth/sign-in/check',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/sign-in/:token',
    element: <MagicLinkLandingNew />,
  },
  // Legacy magic-link URLs kept as aliases for any old in-flight emails (safe to remove later)
  {
    path: '/auth/magic-link/verify',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/magic-link/:token',
    element: <MagicLinkLandingNew />,
  },
  // The "-new" URL aliases stay mounted so any tester bookmarks / inflight
  // invitation links keep working — they're now duplicates of the canonical URLs above.
  {
    path: '/auth/xv7k2m-new/:token',
    element: <VerifyInvitationNew />,
  },
  {
    path: '/auth/np2w8q-new',
    element: <SetPasswordNew />,
  },
  {
    path: '/auth/sign-in-new/check',
    element: <MagicLinkVerifyNew />,
  },
  {
    path: '/auth/sign-in-new/:token',
    element: <MagicLinkLandingNew />,
  },
  // Catch-all route for 404 - must be last
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <AppInitializer>
        <RouterProvider router={router} />
        <SessionInvalidatedModal />
        <SessionExpiredModal />
      </AppInitializer>
    </ThemeProvider>
  );
}

export default App;
